import React, { useContext, useEffect, useState } from 'react';
import './deploiementFonctionnalites.scss';
import AppelerApi from '../../../services/appeler-api.service';
import { Box, Button, Checkbox, Modal, TextField } from '@mui/material';
import AnnulerIcone from '@mui/icons-material/Undo';
import InfoIcone from '@mui/icons-material/Info';
import Select from 'react-select';
import debounce from 'lodash.debounce';
import { baseSelectionneeContext } from '../../../App';

const MODELE_ARCHIVE = 'SPECIAL::Archive';

const DeploiementFonctionnalites = () => {

    const { baseSelectionnee } = useContext(baseSelectionneeContext);
    const [valeurEntree, _] = useState('');
    let [flags, setFlags] = useState([]);
    let [modeles, setModeles] = useState([]);
    let [optionsModeles, setOptionsModeles] = useState([]);
    let [salons, setSalons] = useState([]);
    let [groupes, setGroupes] = useState([]);
    let [notesFlagOuvertes, setNotesFlagOuvertes] = useState({});
    let [optionsSelects, setOptionsSelects] = useState({});
    let saisieNotes = '';
    let [archivageOuvert, setArchivageOuvert] = useState({});

    const listeCriteres = [{ value: 'LOGIN', label: 'Salons par login' }, { value: 'ADMIN_LOGIN', label: 'Admins par login' }, { value: 'FLAG', label: 'Salons par flag défini' }, { value: 'DEMO', label: 'Salons démo ou test' },
        { value: 'DANS_ADMIN', label: 'Salons ayant un admin' }, { value: 'GROUPE', label: 'Salons par groupe' },
        { value: 'MODELE', label: 'Salons par modèle' }, { value: 'ADMIN', label: 'Comptes admin' }];
    const [listeFlags, setListeFlags] = useState([]);
    let [critere, setCritere] = useState(listeCriteres[0]);

    const activerFonctionnaliteModele = (index, flag) => {
        const modeleModifie = JSON.parse(JSON.stringify(modeles[index]));
        modeleModifie[flag] = !modeleModifie[flag] ? 1 : 0;
        const nouvelleListe = Object.assign([ ...modeles], { [index]: modeleModifie });
        setModeles(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: modeleModifie.ID_Enseigne, flag: flag, valeur: modeleModifie[flag] }).then(() => {});
    };

    const modifierSelectFonctionnaliteModele = (index, flag, option) => {
        const modeleModifie = JSON.parse(JSON.stringify(modeles[index]));
        modeleModifie[flag] = option.value;
        const nouvelleListe = Object.assign([ ...modeles], { [index]: modeleModifie });
        setModeles(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: modeleModifie.ID_Enseigne, flag: flag, valeur: modeleModifie[flag] }).then(() => {});
    };

    const activerFonctionnaliteSalon = (index, flag) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie[flag] = !salonModifie[flag] ? 1 : 0;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: salonModifie.ID_Enseigne, flag: flag, valeur: salonModifie[flag] }).then(() => {});
    };

    const modifierSelectFonctionnaliteSalon = (index, flag, option) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie[flag] = option.value;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-feature-flag-actif', { enseigne: salonModifie.ID_Enseigne, flag: flag, valeur: salonModifie[flag] }).then(() => {});
    };

    const retourFlagModele = (index, flag) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        delete salonModifie[flag];
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/supprimer-feature-flag-actif', { enseigne: salons[index].ID_Enseigne, flag: flag }).then(() => {});
    };

    const afficherNotes = (flagObject) => {
        saisieNotes = flagObject.Notes ?? '';
        setNotesFlagOuvertes(flagObject);
    };

    const masquerNotes = () => {
        setNotesFlagOuvertes({});
    };

    const enregistrerNotes = () => {
        const flagModifie = JSON.parse(JSON.stringify(notesFlagOuvertes));
        flagModifie.Notes = saisieNotes;
        const index = flags.findIndex(flag => flag.Flag === flagModifie.Flag);
        const nouvelleListe = Object.assign([ ...flags], { [index]: flagModifie });
        setFlags(nouvelleListe);
        AppelerApi.post('/modifier-notes-feature-flag', { flag: notesFlagOuvertes.Flag, notes: saisieNotes }).then(() => {});
        masquerNotes();
    };

    const modifierModeleSalon = (index, optionModele) => {
        const salonModifie = JSON.parse(JSON.stringify(salons[index]));
        salonModifie.Modele = optionModele.value;
        const nouvelleListe = Object.assign([ ...salons], { [index]: salonModifie });
        setSalons(nouvelleListe);
        AppelerApi.post('/modifier-modele-enseigne', { enseigne: salonModifie.ID_Enseigne, modele: salonModifie.Modele }).then(() => {});
    };

    const modifierCritere = (critere) => {
        setCritere(critere);
        chercherSalon(critere); // Pour critères sans filtre associé
        if (critere.value === 'GROUPE') {
            AppelerApi.get('/lire-groupes').then(data => {
                setGroupes(data.groupes.map(groupe => { return { value: groupe.IDGroupe, label: groupe.Nom } }));
            });
        }
    };

    const rechercheParChaine = debounce((chaine, critereOptionnel) => {
        chercherSalon(critereOptionnel ?? critere, chaine);
    }, 500);

    const chercherSalon = (critere, valeurFiltre) => {
        switch (critere.value) {
            case 'LOGIN':
            case 'ADMIN_LOGIN':
                if (!valeurFiltre || valeurFiltre.length < 3) {
                    return;
                }
                const admin = (critere.value === 'ADMIN_LOGIN');
                AppelerApi.get('/lire-salons-par-enseigne', { enseigne: valeurFiltre, admin }).then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'FLAG':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-feature-flag-actif', { flag: valeurFiltre.value }).then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'DEMO':
                AppelerApi.get('/lire-salons-demo').then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'DANS_ADMIN':
                AppelerApi.get('/lire-salons-dans-admin').then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'ADMIN':
                AppelerApi.get('/lire-admins-ff').then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'GROUPE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-groupe', { IDGroupe: valeurFiltre.value }).then(data => {
                    setSalons(data.salons);
                });
                return;
            case 'MODELE':
                if (!valeurFiltre) {
                    return;
                }
                AppelerApi.get('/lire-salons-par-modele', { modele: valeurFiltre.value }).then(data => {
                    setSalons(data.salons);
                });
                return;
        }
    };

    const demandeArchiver = (e, flag) => {
        if (!e.target.checked) {
            e.stopPropagation();
            e.preventDefault();
            alert('L\'archivage n\'est pas réversible depuis l\'interface');
            return;
        }
        setArchivageOuvert(flag);
    };

    const masquerArchivage = () => {
        setArchivageOuvert({});
    };

    const archiver = () => {
        AppelerApi.post('/archiver-feature-flag', { flag: archivageOuvert.Flag }).then(() => {
            setArchivageOuvert({});
        });
    };

    useEffect(() => {
        AppelerApi.get('/lire-feature-flags-modeles').then(data => {
            for (const flag of data.flags) {
                if (flag.Valeurs_Proposees) {
                    flag.Valeurs_Proposees = JSON.parse(flag.Valeurs_Proposees);
                    const nouvellesOptions = {};
                    nouvellesOptions[flag.Flag] = Object.entries(flag.Valeurs_Proposees).map(([valeur, texte]) => { return { value: valeur, label: texte }});
                    setOptionsSelects(optionsPrecedentes => { return {...optionsPrecedentes, ...nouvellesOptions }; });
                }
            }
            setFlags(data.flags);
            const listeFlags = [];
            for (const flag of data.flags) {
                listeFlags.push({ value: flag.Flag, label: flag.Flag });
            }
            setListeFlags(listeFlags);
            setModeles(data.modeles);
            const optionsModeles = [];
            for (const modele of data.modeles) {
                optionsModeles.push({ value: modele.ID_Enseigne, label: modele.Nom_Modele });
            }
            setOptionsModeles(optionsModeles);
        });
    }, [valeurEntree, baseSelectionnee]);
    return (
        <div className="conteneur-deploiementFonctionnalites">
            <h1>Déploiement de fonctionnalités</h1>
            <div className="bloc-fonctionnel">
                <h2>Fonctionnalités des modèles de clients</h2>
                {
                modeles.length > 0 &&
                (<div className="tableau-flags"><table>
                    <thead>
                        <tr>
                            <th scope="col">Modèle</th>
                            {flags.map(flag => (
                                <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                    {flag.Flag}
                                    <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        <tr key={MODELE_ARCHIVE} className="ligne-activation">
                            <td>Tous (archiver)</td>
                            {flags.map(flag => (
                                <td key={MODELE_ARCHIVE + '_' + flag.Flag} className="cellule-activation">
                                    <Checkbox
                                        onChange={e => demandeArchiver(e, flag)}
                                    />
                                </td>
                            ))}
                        </tr>
                        {Object.entries(modeles).map(([index, modele]) =>
                            <tr key={modele.ID_Enseigne} className="ligne-activation">
                                <td>{modele.Nom_Modele}</td>
                                {flags.map(flag => (
                                    <td key={modele.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                        { (flag.Valeurs_Proposees &&
                                            <Select
                                                value={optionsSelects[flag.Flag].find(option => option.value == modele[flag.Flag])}
                                                options={optionsSelects[flag.Flag]}
                                                onChange={e => modifierSelectFonctionnaliteModele(index, flag.Flag, e)}
                                                className={(modele[flag.Flag] === undefined) ? 'flag-manquant flag-select' : 'flag-select'}
                                            />
                                        ) || (!flag.Valeurs_Proposees &&
                                            <Checkbox
                                                checked={!!modele[flag.Flag]}
                                                onChange={e => activerFonctionnaliteModele(index, flag.Flag)}
                                                className={(modele[flag.Flag] === undefined) ? 'flag-manquant' : ''}
                                            />
                                        )}
                                    </td>
                                ))}
                            </tr>
                        )}
                    </tbody>
                </table></div>)
                }
            </div>
            <div className="bloc-fonctionnel">
                <h2>Fonctionnalités des clients individuels</h2>
                <div className="recherche-salon">
                    <h3>Recherche</h3>
                    <Select
                        placeholder="Critère"
                        value={critere}
                        options={listeCriteres}
                        onChange={modifierCritere}
                        className="taille-input"
                        maxMenuHeight={400}
                    />
                    { (critere.value === 'LOGIN' || critere.value === 'ADMIN_LOGIN') &&
                        <TextField onChange={event => rechercheParChaine(event.target.value)} className="taille-input"/>
                    }
                    { (critere.value === 'FLAG') &&
                        <Select
                            options={listeFlags}
                            onChange={e => chercherSalon(critere, e)}
                            className="taille-input"
                        />
                    }
                    { (critere.value === 'GROUPE') &&
                        <Select
                            options={groupes}
                            onChange={e => chercherSalon(critere, e)}
                            className="taille-input"
                        />
                    }
                    { (critere.value === 'MODELE') &&
                        <Select
                            options={optionsModeles}
                            onChange={e => chercherSalon(critere, e)}
                            className="taille-input"
                        />
                    }
                </div>
                {
                modeles.length > 0 &&
                (<div className="tableau-flags"><table>
                    <thead>
                        <tr>
                            <th scope="col">Salon</th>
                            <th scope="col">Modèle</th>
                            {flags.map(flag => (
                                <th key={flag.Flag} className="nom-flag" title={flag.Nom}>
                                    {flag.Flag}
                                    <InfoIcone className={flag.Notes ? 'notes' : 'notes note-absente'} onClick={e => afficherNotes(flag)}/>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(salons).map(([index, salon]) =>
                            <tr key={salon.ID_Enseigne} className="ligne-activation">
                                <td>{salon.ID_Enseigne}</td>
                                <td>
                                    <Select
                                        placeholder="Modèle à appliquer"
                                        defaultValue={optionsModeles.find(modele => modele.value === salon.Modele)}
                                        options={optionsModeles}
                                        onChange={e => modifierModeleSalon(index, e)}
                                        className={'flag-select'}
                                        menuPlacement={'top'}
                                    />
                                </td>
                                {flags.map(flag => (
                                    (flag.Valeurs_Proposees &&
                                        <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                            <div className="bloc-flag-select-salon">
                                                <Select
                                                    value={optionsSelects[flag.Flag].find(option => option.value == salon[flag.Flag])}
                                                    options={optionsSelects[flag.Flag]}
                                                    onChange={e => modifierSelectFonctionnaliteSalon(index, flag.Flag, e)}
                                                    className="flag-select"
                                                />
                                                { (salon[flag.Flag] === undefined) &&
                                                    <Select
                                                        value={optionsSelects[flag.Flag].find(option => option.value == modeles.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag])}
                                                        options={optionsSelects[flag.Flag]}
                                                        onChange={e => {}}
                                                        isDisabled={true}
                                                        className="flag-select-modele"
                                                    />
                                                }
                                                { (salon[flag.Flag] !== undefined) &&
                                                    <AnnulerIcone className="annuler-flag-select" onClick={e => retourFlagModele(index, flag.Flag)}/>
                                                }
                                            </div>
                                        </td>
                                    ) || (!flag.Valeurs_Proposees &&
                                        <td key={salon.ID_Enseigne + '_' + flag.Flag} className="cellule-activation">
                                            <Checkbox
                                                checked={!!salon[flag.Flag]}
                                                onChange={e => activerFonctionnaliteSalon(index, flag.Flag)}
                                            />
                                            { (salon[flag.Flag] === undefined) &&
                                                <Checkbox
                                                    checked={!!modeles.find(modele => modele.ID_Enseigne === salon.Modele)[flag.Flag]}
                                                    onChange={e => activerFonctionnaliteSalon(index, flag.Flag)}
                                                    className="flag-modele"
                                                    sx={{
                                                        color: '#CCCCCC',
                                                        '&.Mui-checked': {
                                                            color: '#CCCCCC',
                                                        },
                                                    }}
                                                />
                                            }
                                            { (salon[flag.Flag] !== undefined) &&
                                                <AnnulerIcone className="annuler-flag" onClick={e => retourFlagModele(index, flag.Flag)}/>
                                            }
                                        </td>
                                    )
                                ))}
                            </tr>
                        )}
                    </tbody>
                </table></div>)
                }
            </div>
            <Modal open={notesFlagOuvertes.Notes !== undefined} onClose={masquerNotes}>
                <Box className="pop-up">
                    <TextField multiline rows={4} defaultValue={notesFlagOuvertes.Notes} onChange={e => { saisieNotes = e.target.value; }}/>
                    <div className="boutons-pop-up">
                        <Button onClick={masquerNotes}>Fermer</Button>
                        <Button onClick={enregistrerNotes}>Modifier</Button>
                    </div>
                </Box>
            </Modal>
            <Modal open={archivageOuvert.Flag !== undefined} onClose={masquerArchivage}>
                <Box className="pop-up">
                    <p>Êtes-vous sûr de vouloir archiver le flag {archivageOuvert.Flag} {archivageOuvert.Nom ? `(${archivageOuvert.Nom})` : ''} ?</p>
                    <p>Après archivage, la fonctionnalité sera activée pour tous les utilisateurs.</p>
                    <p>L'opération ne peut être annulée que par les développeurs.</p>
                    <div className="boutons-pop-up">
                        <Button onClick={masquerArchivage}>Annuler</Button>
                        <Button onClick={archiver}>Confirmer</Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
};

export default DeploiementFonctionnalites;